export const javascriptCrash = (): never => {
  throw Error('Sentry Test');
};
